// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b275e632","513":"317ba019","703":"3ab48410","787":"c4c066b1"}[chunkId] + ".chunk.js";
};